
























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Message} from "../model/message";
import {messageService} from "../services/messages";
import alertService from "../services/alert";
import db from "@/plugins/firebase";
import authService from "@/services/auth";
import {mapState} from "vuex";

@Component({
  computed: mapState("auth", ["user"])
})
export default class MessageSelectStatus extends Vue {

  @Prop()
  message!: Message;

  stateOptions: string[] = [];
  showHistory = false;
  user: any;

  async mounted() {
    this.stateOptions = await messageService.getStates();
    this.showHistory = await authService.canNavigate('admin-customer',this.user)

    // Here we are defining a variable for this path
    this.$bind('modificationHistory',
      db.collection('messages-data')
      .doc(`${this.message.id}`)
      .collection('history'))
  }

  async updateItem(item: Message) {
    messageService.updateState(item)
      .then(async value => {
        await db
          .collection('messages-data')
          .doc(`${this.message.id}`)
          .collection('history')
          .add({
            'user': this.user.displayName,
            'status': value.state,
            'date': Date.now()
          });
        alertService.success(`State was updated correctly set to ${value.state}`)
      })
      .catch( err => alertService.error('There was an error updating the state'))
  }
}
